export const addPosterUrlToMedia = (media) => {
  if (!media) {
    return undefined;
  }
  const { urlsTranscode = {}, urls = {} } = media;
  if (urlsTranscode?.poster) return urlsTranscode.poster;
  if (urls.optimized) return urls.optimized;

  return undefined;
};
